
// console.log('Vite ⚡️ Rails')
// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')
import "@hotwired/turbo-rails"
import "../controllers"
import "../src"
import "flowbite/dist/flowbite.turbo.js";
import 'flowbite';
// import "./application.js"

// On page load or when changing themes, best to add inline in `head` to avoid FOUC
if (localStorage.getItem('color-theme') === 'dark' || (!('color-theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    document.documentElement.classList.add('dark');
} else {
    document.documentElement.classList.remove('dark')
}